import { render, staticRenderFns } from "./SchoolOrderDetails.vue?vue&type=template&id=3c60bcbc&"
import script from "./SchoolOrderDetails.vue?vue&type=script&lang=ts&"
export * from "./SchoolOrderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolOrderDetails.vue?vue&type=style&index=0&id=3c60bcbc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports